<template>
  <div class="page-wrapper">
    <div class="section-title">
          <div class="left">
            <span style="font-size: 30px">
              <svgIcon iconClass="miniProgram" class="icon" />
            </span>
            <span class="title-name">小程序招商管理</span>
          </div>
          <div class="right"></div>
        </div>
        <div class="page-content-wrapper" v-loading="loading" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)">
          <el-form label-position="top" label-width="80px">
            <el-form-item label="页面头部图片组(小程序显示顺序：从左到右)">
              <imgUpload v-model="headerImages" />
            </el-form-item>
            <el-form-item label="第一个视频">
              <videoUpload
                :videoUrl="video1Url"
                :videoPoster="video1CoverUrl"
                @onChange="onVideoChange1"
              />
            </el-form-item>
            <el-form-item label="第一个视频后的图片组(小程序显示顺序：从左到右)">
              <imgUpload v-model="section0Images" />
            </el-form-item>
            <el-form-item label="表单后的图片组(小程序显示顺序：从左到右)">
              <imgUpload v-model="section1Images" />
            </el-form-item>
            <el-form-item label="第二个视频">
              <videoUpload
                :videoUrl="video2Url"
                :videoPoster="video2CoverUrl"
                @onChange="onVideoChange2"
              />
            </el-form-item>
            <el-form-item label="第二个视频后的图片组(小程序显示顺序：从左到右)">
              <imgUpload v-model="section2Images" />
            </el-form-item>
            <el-form-item label="第二个视频后的轮播图(小程序显示顺序：从左到右)">
              <imgUpload v-model="section3Images" />
            </el-form-item>
            <el-form-item label="页面底部图片组(小程序显示顺序：从左到右)">
              <imgUpload v-model="footerImages" />
            </el-form-item>
            <el-form-item label="小程序页面分享专用封面图(尺寸5:4)">
              <imgUpload :limit="1" v-model="shareCoverUrl" />
            </el-form-item>
            <el-form-item style="text-align:center;margin-top: 80px">
              <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
  </div>
</template>

<script>
import commonMenu from "@/components/menu";
import { mapMutations } from "vuex";
import { throttle, compare } from "@/utils/app";
import { getToken } from "@/utils/auth";
import imgUpload from "@/components/imgUpload/imgUpload";
import videoUpload from "./components/VideoUpload";
import qs from "qs";
export default {
  name: "merchants",
  components: {
    commonMenu,
    imgUpload,
    videoUpload
  },
  data() {
    return {
      loading: false,
      headerImages: [],
      footerImages: [],
      section0Images: [],
      section1Images: [],
      section2Images: [],
      section3Images: [],
      video1Url: "",
      video1CoverUrl: "",
      video2Url: "",
      video2CoverUrl: "",
      shareCoverUrl: []
    };
  },
  computed: {
    onUploadUrl() {
      return this.$api.defaults.baseURL + "/oss/upload";
    },
    headers() {
      return { Authorization: getToken() };
    }
  },
  created() {
    this.featchPageData();
  },
  methods: {
    featchPageData() {
      this.loading = true;
      this.$api
        .get(`/merchants/page`)
        .then(res => {
          if (res.status === 200 || res.status === 206) {
            let {
              footerImages,
              headerImages,
              video1Url,
              video1CoverUrl,
              video2Url,
              video2CoverUrl,
              section0Images,
              section1Images,
              section2Images,
              section3Images,
              shareCoverUrl
            } = res.data;
            this.headerImages = headerImages.sort(compare("sequence"));
            this.footerImages = footerImages.sort(compare("sequence"));
            this.section0Images = section0Images.sort(compare("sequence"));
            this.section1Images = section1Images.sort(compare("sequence"));
            this.section2Images = section2Images.sort(compare("sequence"));
            this.section3Images = section3Images.sort(compare("sequence"));
            this.video1Url = video1Url;
            this.video1CoverUrl = video1CoverUrl;
            this.video2Url = video2Url;
            this.video2CoverUrl = video2CoverUrl;
            this.shareCoverUrl = [
              {
                id: 0,
                sequence: 0,
                url: shareCoverUrl
              }
            ];
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.$message.error("载入小程序招商管理数据失败");
        });
    },
    onVideoChange1(result) {
      let { url, poster } = result;
      this.video1Url = url;
      this.video1CoverUrl = poster;
    },
    onVideoChange2(result) {
      let { url, poster } = result;
      this.video2Url = url;
      this.video2CoverUrl = poster;
    },
    validateForm() {
      let isPass = true;
      if (this.headerImages.length > 0) {
        let emtryExist = this.headerImages.every(ele => {
          return ele.url !== "";
        });
        if (!emtryExist) {
          this.$message.error("页面头部图片组存在异常图片");
          isPass = false;
          return;
        }
      }
      // if (this.video1Url === "") {
      //   this.$message.error("请先上传第一个视频!");
      //   isPass = false;
      //   return;
      // }
      // if (this.video1CoverUrl === "") {
      //   this.$message.error("请先上传第一个视频的封面图!");
      //   isPass = false;
      //   return;
      // }
      if (this.section0Images.length > 0) {
        let emtryExist = this.section0Images.every(ele => {
          return ele.url !== "";
        });
        if (!emtryExist) {
          this.$message.error("第一个视频后的图片组存在异常图片");
          isPass = false;
          return;
        }
      }
      if (this.section1Images.length > 0) {
        let emtryExist = this.section1Images.every(ele => {
          return ele.url !== "";
        });
        if (!emtryExist) {
          this.$message.error("表单后的图片组存在异常图片");
          isPass = false;
          return;
        }
      }
      if (this.section2Images.length > 0) {
        let emtryExist = this.section2Images.every(ele => {
          return ele.url !== "";
        });
        if (!emtryExist) {
          this.$message.error("第二个视频后的图片组存在异常图片");
          isPass = false;
          return;
        }
      }
      if (this.section3Images.length > 0) {
        let emtryExist = this.section3Images.every(ele => {
          return ele.url !== "";
        });
        if (!emtryExist) {
          this.$message.error("第二个视频后的轮播图存在异常图片");
          isPass = false;
          return;
        }
      }
      if (this.footerImages.length > 0) {
        let emtryExist = this.footerImages.every(ele => {
          return ele.url !== "";
        });
        if (!emtryExist) {
          this.$message.error("页面底部图片组存在异常图片");
          isPass = false;
          return;
        }
      }
      // if (this.video2Url === "") {
      //   this.$message.error("请先上传第二个视频!");
      //   isPass = false;
      //   return;
      // }
      // if (this.video2CoverUrl === "") {
      //   this.$message.error("请先上传第二个视频的封面图!");
      //   isPass = false;
      //   return;
      // }
      if (this.shareCoverUrl === "" || this.shareCoverUrl.length <= 0) {
        this.$message.error("请先上传小程序专用页面分享图");
        isPass = false;
        return;
      }
      return isPass;
    },
    onSubmit() {
      if (this.validateForm()) {
        this.loading = true;
        // 按照当前的拖放视图结果设置图片顺序字段
        this.headerImages.map((ele, index) => {
          ele.sequence = index;
        });
        this.footerImages.map((ele, index) => {
          ele.sequence = index;
        });
        this.section0Images.map((ele, index) => {
          ele.sequence = index;
        });
        this.section1Images.map((ele, index) => {
          ele.sequence = index;
        });
        this.section2Images.map((ele, index) => {
          ele.sequence = index;
        });
        this.section3Images.map((ele, index) => {
          ele.sequence = index;
        });
        this.$api
          .put(`/merchants/page`, {
            headerImages: this.headerImages,
            footerImages: this.footerImages,
            section0Images: this.section0Images,
            section1Images: this.section1Images,
            section2Images: this.section2Images,
            section3Images: this.section3Images,
            video1Url: this.video1Url,
            video1CoverUrl: this.video1CoverUrl,
            video2Url: this.video2Url,
            video2CoverUrl: this.video2CoverUrl,
            shareCoverUrl: this.shareCoverUrl[0].url
          })
          .then(res => {
            if (res.status === 201 || res.status === 204) {
              this.$message.success("提交成功");
              this.initForm();
              this.loading = false;
              this.featchPageData();
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
            this.$message.error("提交失败");
          });
      }
    },
    initForm() {
      this.headerImages = [];
      this.footerImages = [];
      this.section0Images = [];
      this.section1Images = [];
      this.section2Images = [];
      this.section3Images = [];
      this.video1Url = "";
      this.video1CoverUrl = "";
      this.video2Url = "";
      this.video2CoverUrl = "";
      this.shareCoverUrl = [];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/custom-variables.scss";
.page-wrapper {
  .limit-winth {
    width: 100%;
    font-size: 14px;
    height: 18px;
    line-height: 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .flex-container {
    display: flex;
    justify-content: space-between;
  }
  .report-left {
    width: 265px;
    flex: 265px 0 0;
    margin-right: 68px;
    overflow: hidden;
  }
  .report-right {
    box-sizing: border-box;
    flex: 1;
    .page-content-wrapper {
      box-sizing: border-box;
      height: 100%;
      text-align: left;
    }
  }
  .section-title {
    width: 100%;
    padding: 19px 0 26px 0;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
    font-size: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      flex: 1;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .right {
      flex: 1;
      text-align: right;
    }
    .title-name {
      font-size: 24px;
      color: #4a4a4a;
      font-weight: bold;
      margin-left: 8px;
    }
  }
  .table-tool-box {
    box-sizing: border-box;
    position: relative;
    // padding: 0 60px 0 0;
    margin-top: 30px;
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    .tool-item {
      box-sizing: border-box;
      padding: 0 10px 0 0;
      flex: 1;
      display: flex;
      text-align: left;
      line-height: 40px;
      box-sizing: border-box;
      font-size: 0;
      &:last-child {
        padding: 0;
      }
      .tool-label {
        flex: 60px 0 0;
        width: 60px;
        text-align: left;
        font-size: 14px;
        font-weight: 450;
        color: #333;
        margin-right: 8px;
      }
      .tool-content {
        flex: 1;
        font-size: 14px;
        color: #333;
      }
    }
    .table-search {
      position: absolute;
      right: 0;
      bottom: 2px;
      width: 50px;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      text-align: center;
      color: #242424;
      border: 1px solid #929292;
      display: inline-block;
      transition: all 0.3s linear;
      &:hover {
        background-color: $theme_color;
        border: 1px solid $theme_color;
        color: #242424;
        cursor: pointer;
      }
    }
  }
}
</style>